import React from 'react'
import { connect } from 'react-redux'
import DocumentTitle from "react-document-title"
import { get } from "lodash"

import { Modal, FormGroup, ControlLabel, FormControl, Table, Row } from 'react-bootstrap'

import AdminNav from '../components/AdminNav.jsx'
import { createExpense, updateExpense, removeExpense } from '../ducks/expenses'
import { docListStyle } from '../containers/PageStyles'
import { ExpenseEditor } from '../components/ExpenseEditor.jsx'
import Button from '../components/Button.jsx'
import { getExpenses, getSortedExpenses, getAllCities, getCitiesIdList } from '../selectors'
import { nameOrTitle, getText, getTextWithTokens } from '../lib/text.js'

function tdStyle(state, id) {
  return { padding: 5, fontWeight: (state.selectedId == id ? 500 : 300) }
}

const CreateForm = ({ value, changeValue, accept, cancel }) => (
  <Modal show onHide={() => cancel()}>
    <Modal.Header>{getText("Crear gasto")}</Modal.Header>
    <Modal.Body>
      <FormGroup>
        <ControlLabel>{getText("Nombre (en español)")}</ControlLabel>
        <FormControl onChange={evt => changeValue(evt.target.value)} value={value} />
      </FormGroup>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={cancel}>{getText("Cancelar")}</Button>
      <Button disabled={!value} bsStyle="success" onClick={accept}>{getText("Crear")}</Button>
    </Modal.Footer>
  </Modal>
)

type Props = {
  expenses: {[string]: Object},
  expensesList: Object[],
  update: (string, Object) => void,
  create: (string, Function) => void,
  remove: (string) => void,
  CitiesList: string[],
  Cities: Object,
}

class ExpensesPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      creating: false,
      newName: "",
      modalKey: null,
      selectedId: null
    }
  }

  props: Props

  select(selectedId) {
    this.setState({ selectedId })
  }

  unselect() {
    this.setState({ selectedId: null })
  }

  remove(id) {
    this.props.remove(id)
  }

  create() {
    this.setState({ newName: "", creating: false });
    this.props.create(this.state.newName, selectedId => this.setState({ selectedId }));
  }

  render() {
    const { expenses, expensesList } = this.props
    const selectedExpense = this.state.selectedId ? expenses[this.state.selectedId] : null

    if (!expenses) return <h3>Loading...</h3>

    return (
      <div style={docListStyle()}>
        <DocumentTitle title= {`Tripmaker ${getText("Gastos")}`} />
        <AdminNav active="expenses" />

        {
          (this.state.creating && (
            <CreateForm
              value={this.state.newName}
              changeValue={newName => this.setState({ newName })}
              accept={() => this.create()}
              cancel={() => this.setState({ newName: "", creating: false })}
            />
          )) || ""
        }

        <Button
          onClick={() => this.setState({ creating: true })}
          style={{ marginRight: 5, marginTop: 5, marginBottom: 5 }}
          glyph="plus"
        >
          {getText("Nuevo gasto")}
        </Button>

        <Row>

          <Table striped bordered>
            <thead>
              <tr>
                {
                  ["", "Ciudad", "Tipo", "Nombre", "Título"].map(x => (
                    <th key={x} style={{textAlign: "center", verticalAlign: "middle"}}>
                      {getText(x)}
                    </th>
                  ))
                }
              </tr>
            </thead>
            <tbody>
              {
                expensesList.map(x => (
                  <tr key={x._id} style={{width: 80}}>
                    <td>
                      <Button
                        bsSize="xsmall"
                        style={{color: "red"}}
                        glyph="remove"
                        onClick={() => {
                          if (confirm(getTextWithTokens("delete_expense", [x.name]))) {
                            this.remove(x._id)
                          }
                        }}
                      />
                      <Button
                        glyph="pencil"
                        bsSize="xsmall"
                        onClick={() => this.select(x._id)}
                      >
                        {getText("editButton")}
                      </Button>
                    </td>
                    <td style={tdStyle(this.state, x._id)}>
                      {
                        this.props.Cities[x.city]
                          ? (
                            <React.Fragment>
                              <div>{get(this.props.Cities, [x.city, "name"], " - ")}</div>
                              <div>{get(this.props.Cities, [x.city, "chinese"], " - ")}</div>
                            </React.Fragment>
                          )
                          : " - "
                      }
                    </td>
                    <td style={tdStyle(this.state, x._id)}>{getText(`expense_type_${x.type || "normal"}`)}</td>
                    <td style={tdStyle(this.state, x._id)}>{x.name || "-"}</td>
                    <td style={tdStyle(this.state, x._id)}>{x.title || "-"}</td>
                  </tr>
                ))
              }
            </tbody>
          </Table>

          {
            selectedExpense && (
              <Modal show onHide={() => this.unselect()}>
                <Modal.Header>
                  <Modal.Title>{nameOrTitle(selectedExpense) || <em>{getText("Gasto sin nombre")}</em>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <ExpenseEditor
                    expense={selectedExpense}
                    onChange={changes => this.props.update(selectedExpense._id, changes)}
                    CitiesList={this.props.CitiesList}
                    pickCity
                    pickType
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.unselect()}>{getText("Cerrar")}</Button>
                </Modal.Footer>
              </Modal>
            )
          }

        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  expenses: getExpenses(state, props),
  // expensesList: sortBy(values(state.expenses || {}), ["city", "name", "title"]),
  expensesList: getSortedExpenses(state, props),
  // CitiesList: sorted(keys(state.cities), (a, b) => a.localeCompare(b)),
  CitiesList: getCitiesIdList(state, props),
  Cities: getAllCities(state, props),
})

const mapDispatchToProps = dispatch => ({
  update: (id, changes) => dispatch(updateExpense(id, changes)),
  create: (name, cb) => dispatch(createExpense({ name }, cb)),
  remove: id => dispatch(removeExpense(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExpensesPage)
